import React from 'react';
import { Link } from 'react-router-dom';

import Icon from 'Core/Components/Icon';

class EmptyState extends React.Component {
  constructor (props) {
    super(props);
  }

  render () {
    let { icon, children } = this.props;
    icon = (icon || 'map-o');

    return (
      <div className="EmptyState tc">
        <Icon fa={icon} />
        <h2>Whoops, there's nothing here.</h2>
        {children}
      </div>
    );
  }
};

export default EmptyState;



// WEBPACK FOOTER //
// ./client/Core/Components/EmptyState.jsx